module.exports = "../dist/frontend/icons/benefits/green/savings.svg?a734bf56072191a24f14947e3c2980dc";